import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Wallet, 
  Briefcase, 
  ClipboardList, 
  Receipt, 
  Users,
  MessageCircle,
  Bot,
  AlertTriangle,
  Calendar,
  Activity
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { filterNavSections } from '../utils/financePermissions';

const navSections = [
  {
    title: 'Main',
    items: [
      { path: '/command-centre', icon: LayoutDashboard, label: 'Command Centre' },
      { path: '/calendar', icon: Calendar, label: 'Calendar' },
      { path: '/communications', icon: MessageCircle, label: 'Communications' },
    ]
  },
  {
    title: 'Business',
    items: [
      { path: '/jobs', icon: Briefcase, label: 'Job Life' },
      { path: '/quotes', icon: ClipboardList, label: 'Quote Life' },
      { path: '/invoices', icon: Receipt, label: 'Invoice Life' },
    ]
  },
  {
    title: 'Finance',
    items: [
      { path: '/finance', icon: Wallet, label: 'Finance Life' },
      { path: '/business-reality', icon: Activity, label: 'Business Reality' },
    ]
  },
  {
    title: 'Assistant',
    items: [
      { path: '/assistant-life', icon: Bot, label: 'Assistant-Life' },
      { path: '/emergency', icon: AlertTriangle, label: 'Emergency Mode', emergency: true },
    ]
  },
  {
    title: 'Portal',
    items: [
      { path: '/client', icon: Users, label: 'Client Portal' },
    ]
  }
];

export function Sidebar() {
  const { user, isFounder } = useAuth();

  const filteredSections = filterNavSections(navSections, user);

  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const getUserRole = () => {
    if (isFounder && isFounder()) return 'Founder';
    if (user?.role === 'MANAGER') return 'Manager';
    return 'User';
  };

  return (
    <aside className="sidebar desktop-sidebar" data-testid="desktop-sidebar">
      {/* Logo */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <h1>Trade<span>Life</span></h1>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {filteredSections.map((section) => (
          <div key={section.title} className="nav-section">
            <div className="nav-section-title">{section.title}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                style={item.emergency ? { color: 'var(--status-danger)' } : {}}
                data-testid={`sidebar-link-${item.path.replace(/\//g, '-').slice(1)}`}
              >
                <item.icon size={18} className="nav-icon" style={item.emergency ? { color: 'var(--status-danger)' } : {}} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="user-avatar">{getInitials(user?.name)}</div>
          <div className="user-info">
            <div className="user-name">{user?.name || 'User'}</div>
            <div className="user-role">{getUserRole()}</div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
